// PANTALLA 5 — Autopercepción (docs/onboarding-master-v2.md, Parte I §4)
//
// ⚠️ BIFURCACIÓN del documento:
//    "Cero absoluto" → salta la calibración y va directo al estilo de feedback.
//    Cualquier otra opción → sigue el camino completo.
// La decisión se toma en el orquestador (DiagnosticoPage) leyendo
// `skipsCalibration` del catálogo PERCEIVED_LEVELS.
//
// ⚠️ [24-09-2026] La segunda pregunta —los intentos previos— se mudó a su
//    propia pantalla (Screen4_5_Intentos.jsx), por la misma razón que la
//    intensidad: apilada debajo nacía fuera del área visible y el alumno no se
//    enteraba de que estaba ahí.
import { useState } from 'react';
import OptionCards from './OptionCards';
import { SCREEN4_HEADLINE, PERCEIVED_LEVELS } from './onboardingContent';
import { etiquetaDePaso } from './pasos';

export default function Screen4_Autopercepcion({ level, onAnswer, onNext }) {
  const [selectedLevel, setSelectedLevel] = useState(level ?? null);

  const handleLevel = (v) => {
    setSelectedLevel(v);
    onAnswer({ perceived_level: v });
  };

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">{etiquetaDePaso(5)}</p>
      <h1 className="ob-headline">
        <span className="ob-headline-linea">{SCREEN4_HEADLINE.linea}</span>
        <span className="ob-bloque">{SCREEN4_HEADLINE.bloque}</span>
      </h1>

      <OptionCards options={PERCEIVED_LEVELS} selected={selectedLevel} onSelect={handleLevel} />

      {selectedLevel && (
        <div className="ob-actions">
          <button type="button" className="ob-btn" onClick={onNext}>
            Continuar →
          </button>
        </div>
      )}
    </div>
  );
}
